"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.between = exports.greaterThan = exports.lessThan = void 0;
var styled_components_1 = require("styled-components");
/*
    --bg-color: blue;
    ${lessThan('small')`
        background-color: var(--bg-color) !important;
    `}
    ${greaterThan('large')`
        background-color: green !important;
    `}
*/
var sizes = {
    small: '576px',
    large: '768px',
};
function getSizeFromBreakpoint(breakpointValue, breakpoints) {
    if (breakpoints[breakpointValue]) {
        return breakpoints[breakpointValue];
    }
    else {
        return '0';
    }
}
var lessThan = function (breakpoint) { return function (style) {
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t@media (max-width: ", ") {\n\t\t\t", "\n\t\t}\n\t"], ["\n\t\t@media (max-width: ", ") {\n\t\t\t", "\n\t\t}\n\t"])), getSizeFromBreakpoint(breakpoint, sizes), (0, styled_components_1.css)(style));
}; };
exports.lessThan = lessThan;
var greaterThan = function (breakpoint) { return function (style) {
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\t@media (min-width: ", ") {\n\t\t\t", "\n\t\t}\n\t"], ["\n\t\t@media (min-width: ", ") {\n\t\t\t", "\n\t\t}\n\t"])), getSizeFromBreakpoint(breakpoint, sizes), (0, styled_components_1.css)(style));
}; };
exports.greaterThan = greaterThan;
var between = function (firstBreakpoint, secondBreakpoint) { return function (style) {
    return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\t@media (min-width: ", ") and (max-width: ", ") {\n\t\t\t", "\n\t\t}\n\t"], ["\n\t\t@media (min-width: ", ") and (max-width: ", ") {\n\t\t\t", "\n\t\t}\n\t"])), getSizeFromBreakpoint(firstBreakpoint, sizes), getSizeFromBreakpoint(secondBreakpoint, sizes), (0, styled_components_1.css)(style));
}; };
exports.between = between;
var templateObject_1, templateObject_2, templateObject_3;
